;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _vueFormWizard = require("vue-form-wizard");

var _vueFormWizard2 = _interopRequireDefault(_vueFormWizard);

var _vuelidate = require("vuelidate");

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _validators = require("vuelidate/lib/validators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.use(_vuelidate2.default);
Vue.use(_vueFormWizard2.default);
exports.default = {
  data: function data() {
    return {
      email_already_taken: true,
      phone_already_taken: true,
      merchant_name_already_taken: true,
      services: null,
      selected_service: [],
      phone_error: null,
      email_error: null,
      errorMsg: null,
      businessForm: {
        bname: "",
        bregno: null,
        baddr: null,
        btaxpin: null,
        bphone: null,
        email: null
      },
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      merchant_id: null,
      agent_type: null
    };
  },

  validations: {
    businessForm: {
      bname: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4),
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmMerchantNameAlreadyTaken(value);
        }
      },
      bregno: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(6)
      },
      baddr: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4)
      },
      btaxpin: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(9)
      },
      bphone: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(12)
      },
      email: {
        required: _validators.required,
        minLength: (0, _validators.minLength)(4),
        isValidEmail: function isValidEmail(value) {
          if (value === "" || value == null) return true;
          return this.validEmail(value);
        },
        alreadyTaken: function alreadyTaken(value) {
          if (value === "" || value == null) return true;
          return this.confirmIfEmailAlreadyTaken(value);
        }
      }
    }
  },
  methods: {
    validEmail: function validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validPhone: function validPhone(phone) {
      var re = /^(254)\d{9}$/;
      return re.test(phone);
    },

    confirmOnlyDigits: function confirmOnlyDigits(phone) {
      var re = /^\d+$/;
      return re.test(phone);
    },

    validPhoneLength: function validPhoneLength(phone) {
      var re = /d{9}$/;
      return re.test(phone);
    },

    validateBusinesDetailsStep: function validateBusinesDetailsStep() {
      if (this.$v.businessForm.$invalid) {
        return false;
      }
      return true;
    },

    confirmIfEmailAlreadyTaken: function confirmIfEmailAlreadyTaken(value) {
      var _this = this;

      var url = "/api/users/all";
      var payload = {
        search: value,
        type: "search"
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this.email_already_taken = false;
        } else {
          _this.email_already_taken = true;
        }
      }).catch(function (error) {
        _this.email_already_taken = true;
      });
      return this.email_already_taken;
    },
    confirmIfPhoneAlreadyTaken: function confirmIfPhoneAlreadyTaken(value) {
      var _this2 = this;

      var url = "/api/users/all";
      var payload = {
        search: value,
        type: "search"
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this2.phone_already_taken = false;
        } else {
          _this2.phone_already_taken = true;
        }
      }).catch(function (error) {
        _this2.phone_already_taken = true;
      });
      return this.phone_already_taken;
    },
    confirmMerchantNameAlreadyTaken: function confirmMerchantNameAlreadyTaken(value) {
      var _this3 = this;

      var url = "/api/merchant/find";
      var payload = {
        search: value
      };
      Vue.axios.get(url, { params: payload }).then(function (response) {
        var data = response.data.items;
        if (data.length > 0) {
          _this3.merchant_name_already_taken = false;
        } else {
          _this3.merchant_name_already_taken = true;
        }
      }).catch(function (error) {
        _this3.merchant_name_already_taken = true;
      });
      return this.merchant_name_already_taken;
    },
    onComplete: async function onComplete() {
      var api_url = "/api/self/signup";
      var data = {
        business_name: this.businessForm.bname,
        business_ra_pin: this.businessForm.btaxpin,
        business_reg_no: this.businessForm.bregno,
        email: this.businessForm.email,
        msisdn: this.businessForm.bphone,
        password: "",
        services: [],

        agent_type: this.agent_type
      };
      var payload = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: (0, _stringify2.default)(data)
      };
      var result = [];

      var _ref = await _sweetalert2.default.fire({
        title: "Terms and conditions",
        input: "checkbox",
        inputValue: 1,
        inputPlaceholder: "I agree with the terms and conditions",
        confirmButtonText: 'Continue&nbsp;<i class="fa fa-arrow-right"></i>',
        showLoaderOnConfirm: true,
        inputValidator: function inputValidator(result) {
          return !result && "You need to agree with T&C";
        },
        preConfirm: function preConfirm() {
          return fetch(api_url, payload).then(function (response) {
            return response.json();
          }).then(function (data) {
            return result.push(data.status);
          }).catch(function () {
            _sweetalert2.default.insertQueueStep({
              icon: "error",
              title: "Unable to process your request"
            });
          });
        }
      }),
          accept = _ref.value;

      if (accept) {
        if (result.toString() == "200") {
          var timerInterval = void 0;
          _sweetalert2.default.fire({
            title: "Registration Sent",
            html: "Please wait, page will be redirected in a few seconds",
            timer: 2500,
            timerProgressBar: true,
            allowOutsideClick: false,
            willOpen: function willOpen() {
              _sweetalert2.default.showLoading();
              timerInterval = setInterval(function () {
                var content = _sweetalert2.default.getContent();
                if (content) {
                  var b = content.querySelector("b");
                  if (b) {
                    b.textContent = _sweetalert2.default.getTimerLeft();
                  }
                }
              }, 100);
            },
            onClose: function onClose() {
              clearInterval(timerInterval);
            }
          }).then(function (result) {
            if (result.dismiss === _sweetalert2.default.DismissReason.timer) {
              window.top.location.href = "/";
            }
          });
        } else {
          _sweetalert2.default.fire({
            icon: "error",
            text: "We are unable to process your request at the moment. If this error persists, kindly contact customer support for further assistance"
          });
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-wizard',{attrs:{"color":"#3498db","error-color":"#ff4949","shape":"tab"},on:{"on-complete":_vm.onComplete}},[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_vm._v("To create an account, complete this wizard")]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Business Info","icon":"ti-settings","before-change":_vm.validateBusinesDetailsStep}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('form',{ref:_vm.businessRuleForm,attrs:{"model":_vm.businessForm,"rules":_vm.rules}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Business Name\n                  "),(!_vm.$v.businessForm.bname.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                    *\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bname),expression:"businessForm.bname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Name","maxlength":"30"},domProps:{"value":(_vm.businessForm.bname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bname", $event.target.value)}}})]),_vm._v(" "),(!_vm.$v.businessForm.bname.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                Name must have at least\n                "+_vm._s(_vm.$v.businessForm.bname.$params.minLength.min)+" letters.\n              ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputPassword4"}},[_vm._v("Business Registration Number\n                  "),(!_vm.$v.businessForm.bregno.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                    *\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bregno),expression:"businessForm.bregno"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Business Registration Number","maxlength":"30"},domProps:{"value":(_vm.businessForm.bregno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bregno", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.bregno.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Reg must have at least\n                  "+_vm._s(_vm.$v.businessForm.bregno.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Email Address")]),_vm._v(" "),(!_vm.$v.businessForm.email.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  *\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.email),expression:"businessForm.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email Address","maxlength":"30"},domProps:{"value":(_vm.businessForm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "email", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.email.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Email must have at least\n                  "+_vm._s(_vm.$v.businessForm.email.$params.minLength.min)+" letters.\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.businessForm.email.isValidEmail)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Invalid email should contain an '@'\n                ")]):_vm._e(),_vm._v(" "),(!_vm.$v.businessForm.email.alreadyTaken)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Email already taken\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Address\n                  "),(!_vm.$v.businessForm.baddr.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                    *\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.baddr),expression:"businessForm.baddr"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"40","placeholder":"1234 Nairobi, Kenya"},domProps:{"value":(_vm.businessForm.baddr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "baddr", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.baddr.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Address must have at least\n                  "+_vm._s(_vm.$v.businessForm.baddr.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Business Tax PIN\n                  "),(!_vm.$v.businessForm.btaxpin.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                    *\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.btaxpin),expression:"businessForm.btaxpin"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"30","placeholder":"A2903XXXXXXXXXH"},domProps:{"value":(_vm.businessForm.btaxpin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "btaxpin", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.btaxpin.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Tax must have at least\n                  "+_vm._s(_vm.$v.businessForm.btaxpin.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":"inputAddress"}},[_vm._v("Business Tel Number\n                  "),(!_vm.$v.businessForm.bphone.required)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                    *\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.businessForm.bphone),expression:"businessForm.bphone"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Phone Number","maxlength":"15"},domProps:{"value":(_vm.businessForm.bphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.businessForm, "bphone", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.businessForm.bphone.minLength)?_c('small',{staticClass:"text-danger",attrs:{"id":"passwordHelp"}},[_vm._v("\n                  Phone number must be at least\n                  "+_vm._s(_vm.$v.businessForm.bphone.$params.minLength.min)+" letters.\n                ")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('label',[_vm._v("Agent Type")])]),_vm._v("\n                \n              "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_type),expression:"agent_type"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"independent","value":"independent"},domProps:{"checked":_vm._q(_vm.agent_type,"independent")},on:{"change":function($event){_vm.agent_type="independent"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"independent"}},[_vm._v("Independent Agent")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_type),expression:"agent_type"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"pesaflow","value":"pesaflow"},domProps:{"checked":_vm._q(_vm.agent_type,"pesaflow")},on:{"change":function($event){_vm.agent_type="pesaflow"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"pesaflow"}},[_vm._v("Pesaflow Agent")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agent_type),expression:"agent_type"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"none","value":"none"},domProps:{"checked":_vm._q(_vm.agent_type,"none")},on:{"change":function($event){_vm.agent_type="none"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"none"}},[_vm._v("None Agent")])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Confirm details","icon":"ti-thumb-up"}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Verify Business Details")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bname}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Registration Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bregno}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.email}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.baddr}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Tax PIN")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.btaxpin}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Business Phone Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.businessForm.bphone}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-5 col-form-label"},[_vm._v("Agent Type")]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.agent_type}})])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Complete Registration","icon":"ti-check"}},[_c('div',{staticClass:"jumbotron jumbotron-fluid"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"display-2"},[_vm._v("Hi "+_vm._s(_vm.businessForm.bname)+",")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Click finish to complete the process. Once submitted, you will\n            receive a confirmation email within 24 hrs to activate and be able\n            to use your new account.\n            "),_c('br'),_vm._v("\n            The Pesaflow Team\n          ")])])])])],1)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f766d2aa", __vue__options__)
  } else {
    hotAPI.reload("data-v-f766d2aa", __vue__options__)
  }
})()}